import {MakeStore, StoreObject} from "../../../stem-core/src/state/Store";
import {field} from "../misc/StoreField";
import {apiClient} from "../../connection/BlinkApiConnection";
import {composePGOptions} from "../../../blink-sdk/CreatePGDefaultOptions";
import {MerchantSDKSettingsStore} from "./MerchantSDKSettingsStore";
import {MerchantPGStore} from "./MerchantPGStore";
import {isPlainObject} from "../../../stem-core/src/base/Utils";


export const MerchantUserJourneyType = {
    DEFAULT: "default",
    AB_TEST: "abTest"
};

class MerchantUserJourney extends StoreObject {
    @field("Merchant") merchant;
    @field(String) name;
    @field options; // JSON
    @field dashboardOptions;

    @field(Date) createdAt;
    @field(Date) lastEditedAt;

    @field(Array) statisticsQueries;
    @field(Array) statistics;

    getActions() {
        const actionOption = this.options?.action ?? [];
        return Array.isArray(actionOption) ? actionOption : [actionOption];
    }

    usesMerchantPG(merchantPG) {
        for (const action of this.getActions()) {
            if (action.pgId && action.pgId === merchantPG.id || action.pgId === merchantPG.name) {
                return true;
            }
        }
        return false;
    }

    getCreatePGAction() {
        return this.getActions().find(action => action.type === "createPG");
    }

    getCreatePGContext() {
        const createPGAction = this.getCreatePGAction();
        const merchantPG = MerchantPGStore.find(pg => pg.name == createPGAction?.pgId || pg.id == createPGAction?.pgId);
        const contexts = composePGOptions({
                ...(createPGAction || {}),
                type: createPGAction?.panelType,
                userJourneyId: this.id,
            },
            MerchantSDKSettingsStore.filterBy({merchantId: this.merchantId})[0]?.defaultPgOptions,
            merchantPG?.options,
            merchantPG?.id,
        ).context;
        return Object.assign({}, ...contexts.filter(context => isPlainObject(context)));
    }

    getABTestableContext() {
        let journeyContexts = this.options.context || {};
        journeyContexts = Array.isArray(journeyContexts) ? journeyContexts : [journeyContexts];
        return Object.assign({}, this.getCreatePGContext(), ...journeyContexts.filter(context => isPlainObject(context)));
    }

    toString() {
        return this.name;
    }

    get type() {
        return this.dashboardOptions.type || MerchantUserJourneyType.DEFAULT;
    }
}

export async function apiCreateMerchantUserJourney(data) {
    return apiClient.post("merchant/create_user_journey/", data);
}

export async function apiUpdateMerchantUserJourney(data) {
    return apiClient.post("merchant/update_user_journey/", data);
}

export async function apiDeleteMerchantUserJourney(merchantUserJourneyId) {
    return apiClient.post("merchant/delete_user_journey/", {merchantUserJourneyId});
}

export async function apiRefreshUserJourneyStatistics(merchantUserJourneyId) {
    return apiClient.post("merchant/refresh_user_journey_statistics/", {merchantUserJourneyId});
}

export const MerchantUserJourneyStore = MakeStore("MerchantUserJourney", MerchantUserJourney);
